<script setup lang="ts">
import AppButton from '@/shared/ui/AppButton/index';
import EditorArticleCard from '@/pages/editorDetail/ui/EditorArticleCard.vue';
import type { IJournalArticle } from '@/entities/journal/model/types';

withDefaults(
  defineProps<{
    articles?: IJournalArticle[];
    isShowMore?: boolean;
  }>(),
  {
    articles: () => [],
    isShowMore: false,
  },
);

const emit = defineEmits<{ (e: 'load'): void }>();

const isMobile: boolean = useIsMobile();

const onLoad = (): void => emit('load');
</script>

<template>
  <div :class="['editor-articles', { _mobile: isMobile }]">
    <h2 class="editor-articles__title">Статьи в журнале</h2>
    <ul class="editor-articles__list">
      <li v-for="article in articles" :key="article.id" class="editor-articles__item">
        <EditorArticleCard :card="article" />
      </li>
    </ul>
    <AppButton
      v-if="isShowMore"
      class="editor-articles__more"
      is-bordered
      is-white
      button-text="Загрузить ещё статьи"
      @click="onLoad"
    />
  </div>
</template>

<style lang="less">
.editor-articles {
  .flex-column(@size-x10);

  &__title {
    font-size: 30px;
    line-height: 130%;
    font-weight: 700;
  }

  &__list {
    .flex-column(@size-x6);
  }

  &__more.app-button {
    align-self: flex-start;
    width: auto;
  }

  &._mobile {
    gap: @size-x6;
  }

  &._mobile &__more.app-button {
    width: 100%;
  }
}
</style>
